import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Clock } from 'lucide-react';

const Footer: React.FC = () => {

  const services = [
    { name: "Cirrhosis", path: "/services/cirrhosis" },
    { name: "Hepatitis B and C", path: "/services/hepatitis" },
    { name: "Liver Cirrhosis", path: "/services/liver-cirrhosis" },
    { name: "Acute Liver Failure", path: "/services/acute-liver-failure" },
    { name: "Hepatocellular Carcinoma", path: "/services/hepatocellular-carcinoma" }
  ];

  return (
    <footer className="bg-charcol text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Dr. Hirak Pahari</h3>
            <p className='text-white mb-4'>
              MBBS, DNB, FMAS, FIAGES, FALS (Oncology), FHBLT
            </p>
            <p className="text-white/90 mb-4 text-sm leading-relaxed">
              Max Super Speciality Hospital<br />
              • Shalimar Bagh, New Delhi - 110088<br />
              • Patparganj, New Delhi - 110092
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.path}>
                  <Link
                    to={service.path}
                    className="text-white hover:text-white transition-colors duration-200"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>

          </div>




          <div>
            <h3 className="text-xl font-semibold mb-4">Key Services</h3>
            <div className="space-y-4">
              <div>
                <h4 className="font-medium mb-2">Liver Transplant</h4>
                <ul className="ml-4 space-y-1">
                  <li>
                    <Link to="/services/liver-transplant/rajendra-nagar" className="text-white hover:text-white transition-colors duration-200">
                      Rajendra Nagar
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/liver-transplant/karol-bagh" className="text-white hover:text-white transition-colors duration-200">
                      Karol Bagh
                    </Link>
                  </li>
                  
                </ul>
              </div>
              
              <div>
                <h4 className="font-medium mb-2">Hepatobiliary Surgery</h4>
                <ul className="ml-4 space-y-1">
                  <li>
                    <Link to="/services/hepatobiliary-surgery/rajendra-nagar" className="text-white hover:text-white transition-colors duration-200">
                      Rajendra Nagar
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/hepatobiliary-surgery/karol-bagh" className="text-white hover:text-white transition-colors duration-200">
                      Karol Bagh
                    </Link>
                  </li>
                  
                
                </ul>
              </div>
              
              <div>
                <h4 className="font-medium mb-2">Intestinal Transplant</h4>
                <ul className="ml-4">
                  <li>
                    <Link to="/services/intestinal-transplant/delhi" className="text-white hover:text-white transition-colors duration-200">
                      Delhi
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>




          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Contact Information</h3>
            <div className="space-y-4">

              <div className="flex items-center space-x-3">
                <Phone className="flex-shrink-0" size={18} />
                <a
                  href="tel:+917827039028"
                  className="text-white hover:text-white"
                >
                  +91 78270 39028
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="flex-shrink-0" size={18} />
                <a
                  href="mailto:hirak.pahari@gmail.com"
                  className="text-white hover:text-white"
                >
                  hirak.pahari@gmail.com
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <Clock className="mt-1 flex-shrink-0" size={18} />
                <p className="text-white">Mon - Sat: 09:00 AM - 05:00 PM</p>
              </div>
            </div>
          </div>

          {/* Certifications */}
          {/* <div>
            <h3 className="text-xl font-semibold mb-4">Education & Training</h3>
            <ul className="space-y-2 text-white">
              <li>ASTS Fellowship - Liver / Kidney Transplant (Detroit, USA)</li>
              <li>Hepatobiliary Surgery</li>
              <li>Intestinal and Multivisceral Transplant Fellowship (Cleveland, Ohio, USA)</li>
              <li>MBBS</li>
              <li>DNB (General Surgery)</li>
              <li>MNAMS</li>
            </ul>
          </div> */}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="mt-12 pt-8 border-t border-white/20 flex flex-col md:flex-col justify-between items-center gap-4">
        <p className="text-sm">
          © {new Date().getFullYear()} Dr. Hirak Pahari. All rights reserved.
        </p>
        <div className="flex gap-4 text-sm">
          <p className="text-sm text-white">
            website by <a href="https://rnahealthtech.com" className="text-slate-100 hover:underline">RNA HealthTech</a>
          </p>
        </div>
      </div>

    </footer>
  );
};

export default Footer;